<template>
  <div class="production-dashboard">
    <!-- 外层 card-m -->
    <card-m
      class="production-info-card"
      cardWidth="100%"
      cardHeight="100%"
      maxHeight="unset"
      :show-filter="false"
    >
      <template slot="card-title">
        <AppBreadcrumb
          page-name="生产信息"
          :list="breadcrumbList"
        >
          <template #right-btn>
            <el-button
              type="primary"
              size="mini"
              @click="goToDesignInfo"
              v-if="currentProductModel"
            >
              上查设计
            </el-button>
          </template>
        </AppBreadcrumb>
      </template>

      <!-- ✅ Grid 主内容区 -->
      <template slot="card-box">
        <div class="project-dashboard">
          <!-- 左列（横向 1 份）：任务详情，占满整列高度 -->
          <div class="basic-info-section">
            <card-m
              title="任务详情信息"
              cardWidth="100%"
              :minHeight="'325px'"
              :cardHeight="'100%'"
              :show-export="true"
              export-file-name="任务详情信息"
              @export="handleExportTaskDetail"
            >
              <template slot="card-box">
                <CardInfoTable
                  ref="taskDetailTable"
                  :data="taskDetailItems"
                  :items-per-row="taskTableColumns"
                  :label-width="isMobile ? '10%' : '30%'"
                  :row-height="isMobile ? '26px' : '28px'"
                  :font-size="isMobile ? '12px' : '14px'"
                  :label-bg-color="'rgba(37, 100, 207, 0.08)'"
                  :border-color="'#dcdfe6'"
                  :hover-effect="!isMobile"
                  :empty-text="''"
                />
              </template>
            </card-m>
          </div>

          <!-- ✅ 右列：吃掉剩余宽度，内部上下平分
                 右上 = 产品列表，右下 = 物料情况 -->
          <div class="main-right">
            <div class="top-list">
              <card-m
                :title="'产品列表 (' + ProductData.length + ')'"
                cardWidth="100%"
                cardHeight="100%"
                :show-export="true"
                export-file-name="产品列表"
                :minHeight="'225px'"
                @export="handleExportProductList"
              >
                <template slot="card-box">
                  <cardTable
                    tableID="productionProductList"
                    :showPaging="false"
                    :tableColumn="productListColumn"
                    :tableData="ProductData"
                    :mobileColumns="mobileProductColumns"
                    @rowClick="goToInfo"
                  />
                </template>
              </card-m>
            </div>

            <div class="bottom-list">
              <card-m
                title="物料情况"
                cardWidth="100%"
                cardHeight="100%"
                :show-export="true"
                export-file-name="物料情况"
                :minHeight="'225px'"
                @export="handleExportMaterialList"
              >
                <template slot="card-box">
                  <cardTable
                    tableID="productionMaterialList"
                    :showPaging="false"
                    :tableColumn="taskListColumn"
                    :mobileColumns="mobiletaskColumns"
                    :tableData="TaskData"
                    @rowClick="goToTaskInfo"
                  />
                </template>
              </card-m>
            </div>
          </div>
        </div>
      </template>
    </card-m>

    <!-- 问题记录弹窗 -->
    <common-dialog-table
      :visible="issueDialogVisible"
      :title="'产品问题记录 - 产品ID: ' + currentProductId"
      :tableColumn="issueListColumn"
      :tableData="issueList"
      @close="closeIssueDialog"
    />
  </div>
</template>




<script>
import {getProductionInfFromTask, getProductionInfFromContract, getProductionInfFromProject,getProductInfoList} from '@/api/mainapi.js';

import { convertDateFormat } from '@/utils/tools.js';
import CommonDialogTable from '@/components/card/CommonDialogTable.vue';
import FileSaver from 'file-saver';
import XLSX from 'xlsx';
export default {
  name: 'classification',
  components: { CommonDialogTable },
  data() {
    return {
      
      taskProgressDialogVisible: false,
      taskProgressLoading: false,
      taskProgressData: [],
      taskProgressTotal: 0,
      taskProgressPage: 1,
      taskProgressPageSize: 5,
      pendingBindingQuantity: 0, // 待绑定产品数量




      ProductData: [], //产品列表
      TaskData: [], //任务列表

      
      //TODO:FAN新增问题记录弹窗相关数据
      issueDialogVisible: false,
      issueList: [],
      issueListColumn: [
        {
          prop: 'create_time',
          label: '创建时间'
        },
        {
          prop: 'field0002',
          label: '问题描述'
        },
        {
          prop: 'SHOWVALUE',
          label: '问题类型'
        }
      ],
      currentProductId: '', // 当前点击的产品ID

  
      productListColumn: [
        // {
        //   prop: 'index',  // 新增序号列
        //   label: '序号',
        //   width: 20,
        // },
        {
          prop: 'serial_code',
          label: '产品编号'
        },
        {
          prop: 'name',
          label: '产品名称'
        },
        {
          prop: 'model',
          label: '产品型号'
        },  
        {
          prop: 'execute_name',
          label: '产品状态'
        },
        {
          prop: 'isIssue',
          label: '有无问题',
          width: 100,
          custom: true,
          column: {
            type: 'tag',
            tag: {
              'true': { text: '有', type: 'danger' },
              'false': { text: '无', type: 'success' }
            }
          }
        },
        
        // 【修改】：图标列（状态指示器）
        {
          prop: '数据状态码', // 【关键字段1】: 接收状态码（0,1,2,空），控制图标颜色
          label: '状态',
          width: 50,
          custom: true,
          column: {
            type: 'icon', // 指定为图标类型
            icon: {
              // 注意：这里不再使用Element UI图标类名，而是自定义样式
              default: 'status-circle' // 自定义的CSS类名，用于渲染实心圆
            },
            tooltipField: '状态详情' // 【关键字段2】: 悬浮提示的内容字段
          }
        },
      ],
      mobileProductColumns: [
        'serial_code',
        'name',
        'execute_name',
        'isIssue',
        '数据状态码'
      ],
      taskListColumn: [
        {
          prop: '代码',
          label: '短代码'
        },
        {
          prop: '名称',
          label: '名称'
        },
        {
          prop: '规格型号',
          label: '型号'
        },
        {
          prop: '投料数',
          label: '投料数'
        },
        {
          prop: '已领',
          label: '已领数'
        },
        {
          prop: '缺料',
          label: '缺料数'
        },
        {
          prop: '库存',
          label: '库存数'
        },
        {
          prop: '在途',
          label: '在途数'
        },

        {
          prop: '标准用量',
          label: '标准用量'
        },
        {
          prop: '单位',
          label: '单位'
        },
        {
          prop: '备注',
          label: '备注'
        },
        // {
        //   prop: '领料标志',
        //   label: '领料状态'
        // },

          // ✅ 领料状态（和产品状态完全一致）
        {
          prop: '数据状态码',
          label: '领料状态',
          custom: true,
          column: {
            type: 'icon',
            icon: {
              default: 'status-circle'
            },
            tooltipField: '领料标志'
          }
        }
      ],
      mobiletaskColumns: [
        // 'index',
        // '项目名称',
        // '项目阶段',
        // '合同总金额',
        '代码',
        '名称',
        '规格型号',
        '缺料',
        '数据状态码',
      ],
      contractInfo: {
        fheadselfs0155: '',
        fheadselfs0159: '',
        fheadselfs0160: '',
        fheadselfs0161: '',
        FCust: '',
        FDept: '',
        FEmp: '',
        finterid: ''
      }, //合同详情

    };
  },
  props: {
    workOrderId: {
      type: String,
      required: true
    },
    contractId: {
      type: String,
      default: ''
    },
    projectName: {
      type: String,
      default: ''
    }
  },
  computed: {
    taskNo() {
      return this.$route.params.workOrderId || '';
    },

    // contractId() {
    //   return this.$route.params.contractId || '';
    // },

    isFromContract() {
      return !!this.contractId;
    },

  projectNo() {
    return this.$route.params.projectNo || '';
  },

  /** ✅ 从缓存读项目名称 */
  projectNameFromCache() {
    if (!this.projectNo) return ''
    return sessionStorage.getItem(`project_name_${this.projectNo}`) || ''
  },

  /** ✅ 项目维度 */
  isFromProject() {
    return !!this.projectNo;   // ✅ 只认 projectNo
  },

  /** ✅ 产品型号：三个入口各存各的 sessionStorage key */
  currentProductModel() {
    let key = 'production_model_from_home';           // 任务单主页
    if (this.isFromProject) key = 'production_model_from_project';   // 项目穿透
    else if (this.isFromContract) key = 'production_model_from_contract'; // 合同穿透
    return sessionStorage.getItem(key)
      || (this.ProductData.length > 0 ? (this.ProductData[0].model || '') : '')
      || '';
  },

  /** ✅ 合同号（用于上查设计） */
  currentContractNoForDesign() {
    return this.contractId
      || sessionStorage.getItem('production_current_contractNo')
      || '';
  },
    /** ✅ 面包屑数据 */
breadcrumbList() {
  const list = [];

  // ✅ 首页
  list.push({
    label: this.isFromProject
      ? '项目主页'
      : this.isFromContract
        ? '合同主页'
        : '任务单主页',
    to: this.isFromProject
      ? '/homepage/projects'
      : this.isFromContract
        ? '/homepage/contracts'
        : '/homepage/workOrders'
  });

      // ✅ 项目维度：项目名（从缓存读取）
      if (this.isFromProject) {
        list.push({
          label: this.projectNameFromCache || this.projectNo,  // ✅ 从缓存读取
          tooltip: this.projectNameFromCache || this.projectNo,
          to: `/homepage/project/${encodeURIComponent(this.projectNo)}`
        });
      }

      // ✅ 合同维度
      if (this.isFromContract) {
        list.push({
          label: this.contractId,
          tooltip: this.contractId,
          to: this.isFromProject
            ? {
                name: '合同信息1',
                params: {
                  projectNo: this.projectNo,
                  contractId: this.contractId
                },
                query: {
                  // projectName: this.projectNameFromCache  // ✅ 从缓存读取
                }
              }
            : {
                name: '合同信息',
                params: { contractId: this.contractId }
              }
        });
      }

      // ✅ 当前任务号
      list.push({
        label: `生产：${this.taskNo}`,
        tooltip: this.taskNo,
        disabled: true
      });

      return list;
},

    taskDetailItems() {
      return [
        { label: '产品名称', value: this.contractInfo.产品名称 },
        { label: '任务状态', value: this.contractInfo.任务状态 },
        { label: '型号', value: this.contractInfo.型号 },
        { label: '短代码', value: this.contractInfo.短代码 },
        { label: '开工时间', value: convertDateFormat(this.contractInfo.开工时间) },
        { label: '装配人员', value: this.contractInfo.装配人员 },
        { label: '交货时间', value: convertDateFormat(this.contractInfo.交货时间) },
        { label: '量程', value: this.contractInfo.量程 || '' },
        { label: '总产品数量', value: this.contractInfo.总产品数量 || 0 },
        { label: '备注', value: this.contractInfo.FNote || '暂无备注' },
        // { label: '待绑定数量', value: this.pendingBindingQuantity },

      ];
    },

  isMobile() {
    return window.innerWidth <= 768;
  },

  taskTableColumns() {
    return this.isMobile ? 2 : 1;
  },  
  },
  mounted() {
    if (this.taskNo) {
      this.getDetilById(this.taskNo);
    } else {
      this.$message.warning('未获取到任务号');
    }
  },
  methods: {

    /** ✅ 上查设计信息 */
    goToDesignInfo() {
      const productModel = this.currentProductModel;
      if (!productModel) {
        this.$message.warning('未获取到产品型号');
        return;
      }

      // 把任务单号和合同号存入 sessionStorage，设计页面从缓存取
      sessionStorage.setItem('design_current_workOrderId', this.taskNo);
      sessionStorage.setItem('design_current_contractNo', this.currentContractNoForDesign);

      if (this.isFromProject) {
        // 项目维度：URL 只含 projectNo + parentModel
        sessionStorage.setItem('design_source', 'project');
        this.$router.push({
          name: '任务设计信息2',
          params: {
            projectNo: this.projectNo,
            parentModel: productModel
          },
          query: {
            // projectName: this.projectNameFromCache
          }
        });
        this.$EventBus.$emit('currentPath',
          `/homepage/project/${encodeURIComponent(this.projectNo)}/design/${encodeURIComponent(productModel)}`);
      } else if (this.isFromContract) {
        // 合同维度：URL 只含 parentModel
        sessionStorage.setItem('design_source', 'contract');
        this.$router.push({
          name: '任务设计信息1',
          params: {
            parentModel: productModel
          }
        });
        this.$EventBus.$emit('currentPath',
          `/homepage/contract/design/${encodeURIComponent(productModel)}`);
      } else {
        // 任务单维度
        sessionStorage.setItem('design_source', 'taskOrder');
        this.$router.push({
          name: '任务设计信息',
          params: {
            parentModel: productModel
          }
        });
        this.$EventBus.$emit('currentPath',
          `/homepage/workOrder/design/${encodeURIComponent(productModel)}`);
      }

      this.$EventBus.$emit('noworkOrder', true);
    },

 
  
    // 根据id查询合同详情（根据来源维度调用不同接口）
    async getDetilById(taskNo) {
      let res;

      if (this.isFromProject) {
        // 项目维度：api/dash/project/production
        res = await getProductionInfFromProject({
          projectNo: this.projectNo,
          contractId: this.contractId,
          taskNo: taskNo
        });
      } else if (this.isFromContract) {
        // 合同维度：api/dash/contract/production
        res = await getProductionInfFromContract({
          contractId: this.contractId,
          taskNo: taskNo
        });
      } else {
        // 任务单维度：api/dash/task/production
        res = await getProductionInfFromTask({
          taskNo: taskNo
        });
      }

      if (res.data.code === 200) {
        // 直接使用接口返回的数据结构
        this.contractInfo = res.data.data.icmoInfo || {}; // 使用icmoInfo作为合同信息
        this.ProductData = res.data.data.products || [];   // 使用products作为产品列表
        this.TaskData = res.data.data.bom || [];          // 使用bom作为任务列表
        
        // 日期格式化处理
        if (this.contractInfo.FPlanFinishDate) {
          this.contractInfo.FPlanFinishDate = convertDateFormat(this.contractInfo.FPlanFinishDate);
        }

        // 新增：计算待绑定产品数量
        this.calculatePendingBindingQuantity();   
        
        // 为每个产品添加序号
        this.ProductData.forEach((product, index) => {
          product.index = index + 1;
        });

        this.ProductData.forEach(product => {
          product.数据状态码 =
            product.process_name === '开工' ? 2 :
            product.process_name === '完工' ? 1 :
            product.process_name === '异常' ? 0 :
            '';
          // 悬浮提示显示关联的产品状态文字
          product['状态详情'] = product.process_name || product.execute_name || '';
        });

// ✅ 物料情况状态码（新增）
this.TaskData.forEach(task => {
  const flag = (task['领料标志'] || '').toString();

  if (flag.includes('发')) {
    task.数据状态码 = 3;
  } else if (flag.includes('缺料')) {
    task.数据状态码 = 0;
  } else if (flag.includes('齐料')) {
    task.数据状态码 = 1;
  } else {
    task.数据状态码 = 2;
  }

  // ✅ 缺料数：后端字段名不固定，有时发「缺料」，有时发「现场缺料」
  //    哪个字段传来了（有值）就显示哪个，统一归一化到表格列 prop「缺料」上。
  //    ⚠️ 在数据层归一而不是改列定义：card-table 普通列是直接取 scope.row[prop]，
  //       只认单个字段名、没有 formatter；归一后列表展示 / 排序 / 筛选 / 导出全部一致。
  //    ⚠️ 0 是有效值（确实不缺料），不能用真值判断，否则会被误当成"没传"而取另一个字段。
  const hasValue = v => v !== undefined && v !== null && v !== '';
  const shortage = task['缺料'];
  const onsiteShortage = task['现场缺料'];
  task['缺料'] = hasValue(shortage)
    ? shortage
    : (hasValue(onsiteShortage) ? onsiteShortage : '');
});        
     
      } else {
        this.$message.error('获取合同详情失败');
      }
    },

    // 计算待绑定产品数量
    calculatePendingBindingQuantity() {
      // 总产品数量（从合同信息获取）
      const totalQuantity = parseInt(this.contractInfo.总产品数量) || 0;
      
      // 已绑定产品数量（产品列表中的产品总数）
      const boundQuantity = this.ProductData.length;
      
      // 待绑定产品数量 = 总产品数量 - 已绑定产品数量
      this.pendingBindingQuantity = Math.max(0, totalQuantity - boundQuantity);
    },

      // 序号列索引方法
    indexMethod(index) {
      return index + 1;  // 从1开始编号
    },


    // TODO:FAN产品列表行点击事件 - 查询问题记录
    async goToInfo(data) {
      
      // 保存当前点击的产品ID
      this.currentProductId = data.id;
      
      try {
        // 调用后端接口查询问题记录
        const params = {
          Type: 'ProductIssue',
          msg: data.id.toString() // 确保是字符串类型
        };
        
        const res = await getProductInfoList(params);
        
        if (res.data.code === 200) {
          if (res.data.data.issue === '空' || !res.data.data.issue || res.data.data.issue.length === 0) {
            // 问题记录为空
            this.$message.info('该产品没有问题记录');
          } else {
            // 有问题记录，显示弹窗
            this.issueList = res.data.data.issue;
            this.issueDialogVisible = true;
          }
        } else {
          this.$message.error('查询问题记录失败: ' + res.data.message);
        }
      } catch (error) {
        this.$message.error('查询问题记录失败');
      }
    },

    // TODO:FAN关闭问题记录弹窗
    closeIssueDialog() {
      this.issueDialogVisible = false;
      this.issueList = [];
      this.currentProductId = '';
    },

    /** 导出：任务详情信息 */
    handleExportTaskDetail() {
      if (this.$refs.taskDetailTable && this.$refs.taskDetailTable.handleExport) {
        this.$refs.taskDetailTable.handleExport();
      }
    },

    /** 导出：产品列表 */
    handleExportProductList() {
      const el = document.querySelector('#productionProductList');
      if (!el) return;
      const wb = XLSX.utils.table_to_book(el, { raw: true });
      const wbout = XLSX.write(wb, { bookType: 'xlsx', bookSST: true, type: 'array' });
      try {
        FileSaver.saveAs(new Blob([wbout], { type: 'application/octet-stream' }), '产品列表.xlsx');
      } catch (e) { /* ignore */ }
    },

    /** 导出：物料情况 */
    handleExportMaterialList() {
      const el = document.querySelector('#productionMaterialList');
      if (!el) return;
      const wb = XLSX.utils.table_to_book(el, { raw: true });
      const wbout = XLSX.write(wb, { bookType: 'xlsx', bookSST: true, type: 'array' });
      try {
        FileSaver.saveAs(new Blob([wbout], { type: 'application/octet-stream' }), '物料情况.xlsx');
      } catch (e) { /* ignore */ }
    }
  }
};
</script>

<style scoped lang="scss">

/* 桌面端表格与卡片的固定边距 */
$table-inset: 12px;

/* 手机端三张卡的高度（想调就改这里） */
$m-basic-h: 190px;        /* 任务详情：固定高度 */
$m-top-h: 200px;          /* 产品列表：固定高度 */
$m-bottom-min-h: 250px;   /* 物料情况：最小高度（屏幕太矮时兜底） */

/* ============================================================
   布局（和 designinfo.vue 同一套逻辑）
   ------------------------------------------------------------
   高度链：
     .main-view(homepage，height:100% + min-height:560px)
       → .production-dashboard(height:100%)
         → .card-main(外层 card-m，height:100%)
             ├─ .card-top  ← card-title（面包屑），自动高度
             └─ .card-box  ← ★ = card-main 高度 − card-title 高度
                  → .project-dashboard（内部 Grid）
                      ├─ 左：basic-info-section（固定宽度 $left-w，占满整列高度）
                      └─ 右：top-list / bottom-list（上下平分剩余高度）
   ------------------------------------------------------------
   想调宽度只改下面这两个变量
   ============================================================ */
$left-w: 360px;        /* 左侧「任务详情」卡片的固定宽度 */
$right-min-w: 420px;   /* 右侧两张卡片的最小宽度（窗口再窄也不压扁表格） */

/* 页面根：撑满 .main-view */
.production-dashboard {
  height: 100%;
  box-sizing: border-box;
}

/* 外层 card-m：撑满页面 + 不要边框 / 阴影（电脑 & 手机都不要） */
.production-info-card {
  height: 100% !important;
  width: 100% !important;
  border: none !important;
  box-shadow: none !important;
}

/* ⚠️★ 真正修掉「card-box 超出 main-view」的一步
   card-M 里 .card-box 写死的是 height:100%，跟上面的 .card-top(card-title) 一叠加就超出 card-main；
   更关键的是：.card-box 是 .card-main(flex 列) 的 flex 项，默认 min-height:auto
   （自动最小尺寸 = 内容的 min-content 高度），内容一高它就拒绝收缩，
   直接把 card-main / main-view 顶破 —— 这就是溢出的根因。
   三条一起改：
     flex:1 1 auto → 正好吃掉「card-main 减去 card-title」的剩余高度
     min-height:0  → 解除 flex 项「不能小于内容高度」的限制（★ 关键就是它）
     height:auto   → 别再按 100% 算，高度交给 flex 分配 */
.production-info-card ::v-deep .card-box {
  flex: 1 1 auto !important;
  height: auto !important;
  min-height: 0 !important;
  box-sizing: border-box;

  /* ⚠️★ 必须变成 flex 列容器（card-M 里 .card-box 默认是 block）
     它的 height 是 auto，里面 .project-dashboard 的 height:100% 就解析不出来
     —— 百分比遇到 auto 父级会退化成 auto，Grid 变成「按内容撑高」：
        两行既不是对半分，内容一多还会互相盖住（这正是 el-main 出滚动条时看到的现象）。
     改成 flex 后，.project-dashboard 靠 flex:1 拿到确定高度，minmax(0,1fr) 才能真正对半分。 */
  display: flex !important;
  flex-direction: column !important;
}

/* ✅ 整体左右分布 Grid（对应 designinfo 的「上下分布」，转了 90°）
   ------------------------------------------------------------
   designinfo    ：上（固定高度） + 下左 / 下右（左右平分）
   productioninfo：左（固定宽度） + 右上 / 右下（上下平分）
   ------------------------------------------------------------
     左   = basic-info-section  固定宽度 $left-w，占满整列高度
     右   = .main-right         吃掉剩余宽度（最少 $right-min-w）
     右上 = top-list（产品列表）
     右下 = bottom-list（物料情况）
   ⚠️ 卡片间距交给 grid 的 gap（和 designinfo 一样 10px）；
      卡片外观（边框 / 圆角 / 阴影 / 底色）由 card-M.vue 统一提供 */
.project-dashboard {
  /* ⚠️ 不要只写 height:100%
     父级 .card-box 的 height 是 auto，百分比解析不出来会退化成 auto，
     Grid 就变成按内容撑高 —— 两行不对半分，内容还互相盖住。
     改由 flex 撑满 card-box（card-box 已改成 flex 列容器），高度才是确定的。 */
  flex: 1 1 auto !important;
  min-height: 0 !important;
  width: 100%;
  box-sizing: border-box;

  display: grid;
  grid-template-columns: $left-w minmax($right-min-w, 1fr);   /* ✅ 左固定，右吃剩余 */
  grid-template-rows: 1fr;
  grid-template-areas:
    "basic-info main-right";
  gap: 10px;
}

/* 左列：任务详情（占满整列高度） */
.basic-info-section {
  grid-area: basic-info;
  display: flex;
  flex-direction: column;
  box-sizing: border-box;
  min-height: 0;   /* ✅ 关键：允许压缩，表格才能在卡片内部滚 */
  min-width: 0;    /* ✅ 关键：防止表格内容把格子撑宽 */
}

/* ✅ 右列：吃掉剩余宽度，内部上下平分（对应 designinfo 的 .main-bottom） */
.main-right {
  grid-area: main-right;
  display: grid;
  grid-template-columns: 1fr;
  grid-template-rows: minmax(0, 1fr) minmax(0, 1fr);   /* ✅ 右上 / 右下 上下平分 */
  gap: 10px;
  min-height: 0;
  min-width: 0;
  box-sizing: border-box;
}

/* ✅ 右上 / 右下 两张卡片
   ⚠️ 上面 .main-right 用 minmax(0, 1fr) 而不是 1fr：
      1fr = minmax(auto, 1fr)，min 那个 auto = 内容的 min-content 高度，
      表格行数一多它就拒绝收缩，把 .main-right 撑得比容器还高 ——
      那样「平分」的是被内容撑出来的空间，不是 main-view 的空间，页面还会溢出。
      min 写成 0，两行才严格按 main-view 的剩余高度对半分，
      多出来的内容在各自卡片内部滚（card-box / el-table__body-wrapper 都有 min-height:0）。 */
.top-list,
.bottom-list {
  display: flex;
  flex-direction: column;
  box-sizing: border-box;
  min-height: 0;   /* ✅ 关键 */
  min-width: 0;    /* ✅ 关键 */
}

/* ✅ 三个卡片的内层链：只管「撑满格子 + 能收缩」
   ⚠️ 卡片外观（边框 / 圆角 / 阴影 / 底色 / margin）全部由 card-M.vue 统一提供，
      原先这里私自定义的 border / box-shadow / margin:0 已全部删掉；
      （card-M 现在的默认就是「四边 1px 描边 + 阴影 + margin:0」，不需要再写一遍）
      card-M 的根类名是 .card-main，原来那条 ::v-deep .card-m 匹配不到任何元素，一并删掉 */
.basic-info-section ::v-deep .card-main,
.top-list ::v-deep .card-main,
.bottom-list ::v-deep .card-main {
  flex: 1;
  display: flex;
  flex-direction: column;
  height: 100%;
  min-height: 0;
  min-width: 0;
  width: 100%;
}

/* card-box：比 card-main 再往里收一圈，表格不会压到卡片边框上 */
.basic-info-section ::v-deep .card-box,
.top-list ::v-deep .card-box,
.bottom-list ::v-deep .card-box {
  flex: 1;
  display: flex;
  flex-direction: column;
  min-height: 0;   /* ✅ 关键 */
  box-sizing: border-box;
  padding: $table-inset; // 表格离卡片四周的固定边距
}

/* 任务详情：格子高度不够时内部滚动，不撑破 1:2 的比例 */
.basic-info-section ::v-deep .card-box { overflow: auto; }
.basic-info-section ::v-deep .card-info-table { width: 100%; }

.top-list ::v-deep .card-table,
.bottom-list ::v-deep .card-table {
  flex: 1;
  display: flex;
  flex-direction: column;
  min-height: 0;   /* ✅ 关键 */
}

/* ✅ Element Table 必杀三句 */
.top-list ::v-deep .el-table,
.bottom-list ::v-deep .el-table {
  flex: 1;
  display: flex;
  flex-direction: column;
  height: 100%;
}

.top-list ::v-deep .el-table__body-wrapper,
.bottom-list ::v-deep .el-table__body-wrapper {
  flex: 1;
  overflow-y: auto;
  min-height: 0;   /* ✅ 这是防止撑出的关键 */
}




/* ✅ 响应式（小屏） */
/* ======================
   手机端：完全复刻 designinfo.vue 的手机模式
   ------------------------------------------------------------
   设计信息页面的手机端结构（嵌套 Grid + 固定 / 吃剩余）：
     .main-view → card-m (外层) → card-box
       → .design-grid-container (Grid，1 列 2 行)
           ├─ .main-top    = $m-top-h      (设计进度条，固定高度)
           └─ .main-bottom = 1fr           (吃剩余，内部再分两行)
               ├─ .bottom-left  = $m-info-h (合同信息，固定高度)
               └─ .bottom-right = 1fr       (资料详情，吃剩余)

   生产信息页面（这张页）的手机端结构（同样的嵌套套路）：
     .main-view → card-m (外层) → card-box
       → .project-dashboard (Grid，1 列 2 行)
           ├─ .basic-info-section = $m-basic-h  (任务详情，固定高度)
           └─ .main-right         = 1fr         (吃剩余，内部再分两行)
               ├─ .top-list    = $m-top-h       (产品列表，固定高度)
               └─ .bottom-list = 1fr           (物料情况，吃剩余)

   高度链：所有高度都由外层 card-box 的 flex 分配决定，**不写 100vh**，
   保证 main-view 滚动时 Grid 容器高度始终是「main-view − card-title」，
   三张卡片永远刚好占满一屏、不会互相盖住、底部不会被裁。
   ------------------------------------------------------------
   想调手机端高度只改顶部那三个变量（$m-basic-h / $m-top-h / $m-bottom-min-h）
   ====================== */
@media (max-width: 768px) {

  /* ✅ 外层 Grid：1 列 2 行，任务详情固定 + 右列吃剩余
     （对应 designinfo 的 .design-grid-container） */
  .project-dashboard {
    display: grid !important;
    grid-template-columns: 1fr !important;
    grid-template-rows: $m-basic-h 1fr !important;
    grid-template-areas:
      "basic-info"
      "main-right" !important;

    height: 100% !important;
    min-height: 0 !important;
    max-height: none !important;
    box-sizing: border-box;

    gap: 8px;                 /* 和 designinfo 一致 */
    padding: 0;               /* 和 designinfo 一致（页边距交给 card-M 默认） */
  }

  /* ✅ 任务详情：撑满第一行 = 固定 $m-basic-h
     内容超出时在自己的 card-box 内部滚（桌面端的 overflow:auto 仍然生效） */
  .basic-info-section {
    grid-area: basic-info !important;
    height: 100% !important;
    min-height: 0 !important;
    max-height: none !important;
  }

  /* ✅ 右列 main-right：2 行 Grid（对应 designinfo 的 .main-bottom）
     产品列表固定 + 物料情况吃剩余（1fr） */
  .main-right {
    grid-area: main-right !important;
    display: grid !important;
    grid-template-columns: 1fr !important;
    grid-template-rows: $m-top-h 1fr !important;
    gap: 8px;
    min-height: 0;
    min-width: 0;
    box-sizing: border-box;
  }

  /* ✅ 产品列表：撑满第一行 = 固定 $m-top-h
     卡片外观（边框 / 圆角 / 阴影）由 card-M.vue 提供 */
  .top-list {
    height: 100% !important;
    min-height: 0 !important;
    max-height: none !important;
  }

  /* ✅ 物料情况：撑满第二行 = 1fr 吃剩余，最小 $m-bottom-min-h 兜底
     ⚠️ 覆盖桌面端的「50/50 平分」，这里改成「吃剩余 + 最小高度」
     ⚠️ flex / overflow / margin 也清掉，让 card-M 默认样式生效（和 designinfo 一致） */
  .bottom-list {
    height: 100% !important;
    min-height: $m-bottom-min-h !important;
    max-height: none !important;
    flex: unset !important;
    overflow: visible !important;
    margin: 0 !important;
  }

  /* ✅ 覆盖模板上残留的 :minHeight（任务详情 325 / 产品列表 225 / 物料情况 225）
     —— 这些是行内 style，没有 !important，手机端用 !important 覆盖，
     否则三张卡的内层 card-main 都会撑到各自的 min，撑破上面 Grid 分配的固定高度 */
  .basic-info-section ::v-deep .card-main,
  .top-list ::v-deep .card-main {
    min-height: 0 !important;   /* 让 Grid 单元格的 $m-basic-h / $m-top-h 决定高度 */
  }
  .bottom-list ::v-deep .card-main {
    min-height: $m-bottom-min-h !important;   /* 兜底 150px，和 .bottom-list 对齐 */
  }

  /* ✅ Element Table 占满 + 内部滚动（和 designinfo 一模一样） */
  .top-list ::v-deep .el-table,
  .bottom-list ::v-deep .el-table {
    flex: 1 !important;
    display: flex !important;
    flex-direction: column !important;
    min-height: 0 !important;
    width: 100% !important;
  }

  .top-list ::v-deep .el-table__body-wrapper,
  .bottom-list ::v-deep .el-table__body-wrapper {
    flex: 1 !important;
    overflow-y: auto !important;
    min-height: 0 !important;
    width: 100% !important;
  }

  /* ✅ 表头 / 单元格字号收紧（和 designinfo 一致） */
  .top-list ::v-deep .el-table th,
  .bottom-list ::v-deep .el-table th {
    font-size: 11px !important;
    padding: 4px 0 !important;
  }

  .top-list ::v-deep .el-table td,
  .bottom-list ::v-deep .el-table td {
    font-size: 11px !important;
    padding: 3px 0 !important;
  }

  /* ✅ 任务详情卡片字号收紧（这张页特有） */
  .basic-info-section ::v-deep .value-cell {
    font-size: 12px !important;
  }
}

</style>




